<template>
  <el-upload
    class="avatar-uploader"
    :show-file-list="false"
    :action="action"
    :headers="headers"
    :multiple="false"
    accept=".jpg"
    :before-upload="beforeUpload"
    :on-success="handlerSuccess"
    :on-error="handlerError"
    :on-remove="handlerRemove"
    :data="fromdata"
  >
    <img v-if="src" :src="src" class="avatar" />
    <div v-else class="avatar-uploader-icon">{{ label }}</div>
  </el-upload>
</template>

<script>
export default {
  props: {
    url: {
      //图片路径
      type: String,
      default: "",
    },

    label: {
      type: String,
      default: "图片",
    },
    /**照片类型 默认:carimg 车辆信息照片 */
    type: {
      type: String,
      default: "carimg",
    },
  },
  data() {
    return {
      headers: { Authorization: "Bearer " + this.$g.getToken() },
      loadingInstance: null,
      fromdata: {},
      src: "",
    };
  },
  watch: {
    url(e) {
      this.src = e; //初始化绑定url属性 或上传完成图片更新data中的url,vue  中不子组件支持直接更改props中的内容
    },
  },
  computed: {
    action() {
      this.fromdata = { type: this.type };
      return this.$g.host + "/api/Common/UploadPhoto";
    },
  },
  methods: {
    beforeUpload(file) {
      // var filetype = new string[] { "image/jpg", "image/jpeg", "image/png" };
      const isJPG = file.type === "image/jpeg";
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 格式!");
        return false;
      }
      this.loadingInstance = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    handlerSuccess(res) {
      if (res.Code == "1") {
        this.src = res.Result.url;

        this.$emit("success", res.Result.path); //v-model绑定数据库中要存储的图片路径
      } else {
        this.$emit("success", "");
      }
      if (this.loadingInstance) {
        this.loadingInstance.close();
      }
      this.$message.success("上传成功");
    },
    handlerError(error) {
      if (this.loadingInstance) {
        this.loadingInstance.close();
      }
      this.$alert("数据请求异常,请联系管理员", "发生错误");
      this.$emit("error");
    },
    handlerRemove() {
      this.$emit("error");
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-upload .el-upload__input {
  display: none !important; /* 隐藏默认的文件选择输入框 */
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 16px;
  color: #8c939d;
  width: 130px;
  height: 130px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 130px;
  height: 130px;
  display: block;
}
</style>